import { parseBrand } from './parse-brand';

export type { Brand } from './parse-brand';

export const brand = parseBrand(import.meta.env);
